import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderService } from './loader.service';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private isCompletedMain = new BehaviorSubject<any>({isCompleted : false , index : -1});
  isCompleted = this.isCompletedMain.asObservable();
  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
    private loader : LoaderService
  ) { }

  apiErrorMessageDialog(trnID: any, errorCode: string) {
    let errorMessage = this.translate.instant(errorCode);
    const dialogRef = this.dialog.open(NotificationComponent, {
      panelClass: ['dialog-responsive'],
      disableClose: true,
      data: { error: true, trnID, errorMessage }
    });
    dialogRef.afterClosed().subscribe();
  }

  handleStatusError(error: any): void {
    if (
      error.error.rcode !== 401 &&
      error.error.rcode !== 403 &&
      error.error.rcode !== 404 &&
      error.error.rcode !== 500
    ) {
      const errorCode = error.error.rmsg[0]?.errorCode ?? 'ERROR';
      const errorMessage = this.translate.instant(errorCode);

      console.error('Error Receiving data:', error);

      const _dialogRef = this.dialog.open(NotificationComponent, {
        width: '50VW',
        disableClose: true,
        data: {
          panelClass: ['dialog-responsive'],
          disableClose: true,
          error: true, trnID: error.error.transactionRef, errorMessage
        },
      });

      _dialogRef.afterClosed().subscribe();
    }
  }
  handleRcodeError(data: any): void {
    const errorCode = data.rmsg[0]?.errorCode ?? 'ERROR';
    const errorMessage = this.translate.instant(errorCode);

    console.error('Error Receiving data:', data);

    const dialogRef = this.dialog.open(NotificationComponent, {
      panelClass: ['dialog-responsive'],
      disableClose: true,
      data: {
        error: true,
        trnID: data.transactionRef,
        errorMessage,
      },
    });

    dialogRef.afterClosed().subscribe();
  }
  checkStatusErrors(error: any){
    this.loader.hide();
    if (
      error.error.rcode !== 401 &&
      error.error.rcode !== 403 &&
      error.error.rcode !== 404 &&
      error.error.rcode !== 500
    ) {
      this.handleStatusError(error);
    }
  
  }

}
